import React from 'react';

import { Box } from '@mui/material';

import type { ScreenshotSkeletonProperties } from './ScreenshotSkeleton.types';

export const ScreenshotSkeleton: React.FC<ScreenshotSkeletonProperties> = ({
  dataTest = 'screenshot_skeleton',
}) => (
  <Box data-testid={dataTest} sx={{ height: 160, backgroundColor: 'grey.100' }} />
);
